<div class="tag-dialog p-1">
  <!-- Form Fields -->
  <div class="space-y-4">
    <!-- Label Encoding - Required -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Label Encoding <span class="text-red-500">*</span>
      </label>
      <input
        type="text"
        pInputText
        placeholder="Please enter"
        [(ngModel)]="formData.labelEncoding"
        class="w-full"
        [class.border-red-300]="showErrors() && !formData.labelEncoding"
      />
      @if (showErrors() && !formData.labelEncoding) {
      <p class="text-red-500 text-xs mt-1">Label Encoding is required</p>
      }
    </div>

    <!-- Type - Required -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Type <span class="text-red-500">*</span>
      </label>
      <p-select
        [options]="typeOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Please select"
        [(ngModel)]="formData.type"
        (ngModelChange)="onTypeChange($event)"
        styleClass="w-full"
        [class.border-red-300]="showErrors() && !formData.type"
      />
      @if (showErrors() && !formData.type) {
      <p class="text-red-500 text-xs mt-1">Type is required</p>
      }
    </div>

    <!-- Description -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Description
      </label>
      <input
        type="text"
        pInputText
        placeholder="Please enter"
        [(ngModel)]="formData.description"
        class="w-full"
      />
    </div>

    <!-- Toggle Switches -->
    <div class="space-y-4">
      <!-- Status Toggle -->
      <div class="flex items-center justify-between">
        <label class="text-sm font-medium text-gray-700">Status</label>
        <p-toggleSwitch [(ngModel)]="formData.status" />
      </div>

      <!-- Is Inheritable Toggle -->
      <div class="flex items-center justify-between">
        <label class="text-sm font-medium text-gray-700">Is Inheritable</label>
        <p-toggleSwitch [(ngModel)]="formData.isInheritable" />
      </div>

      <!-- Is Page Visible Toggle -->
      <div class="flex items-center justify-between">
        <label class="text-sm font-medium text-gray-700">Is Page Visible</label>
        <p-toggleSwitch [(ngModel)]="formData.isPageVisible" />
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-200">
    <p-button
      label="Cancel"
      severity="secondary"
      [outlined]="true"
      (onClick)="onCancel()"
    />
    <p-button label="Confirm" severity="info" (onClick)="onConfirm()" />
  </div>
</div>
